import script from "./ImportTeresaStandard.vue?vue&type=script&setup=true&lang=js"
export * from "./ImportTeresaStandard.vue?vue&type=script&setup=true&lang=js"

import "./ImportTeresaStandard.vue?vue&type=style&index=0&id=24f5898b&lang=css"

const __exports__ = script;

export default __exports__